import { AutoLink, type AutoLinkProps } from '@betterment/js-runtime';
import { Link, type LinkProps } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';

export type SambaAutoLinkProps = AutoLinkProps & LinkProps;

const SambaAutoLinkBase: React.FC<SambaAutoLinkProps> = ({
  to,
  children,
  prefetch,
  preventScrollReset,
  reloadDocument,
  viewTransition,
  ...linkProps
}) => {
  const reactRouterProps = { prefetch, preventScrollReset, reloadDocument, viewTransition };
  return (
    <Link asChild={true} {...linkProps}>
      <AutoLink to={to} {...reactRouterProps}>
        {children}
      </AutoLink>
    </Link>
  );
};

const unstyledStyles = css.raw({
  color: 'inherit',
  _hover: {
    color: 'inherit',
    textDecoration: 'none',
    '& .underlineOnHover': { textDecoration: 'underline' },
  },
  _active: {
    color: 'inherit',
    textDecoration: 'none',
  },
});

/**
 * A variant of SambaAutoLink that removes default link styles (color, underline).
 * Add `className="underlineOnHover"` to any child element to have it underline when the link is hovered.
 */
const Unstyled: React.FC<SambaAutoLinkProps> = ({ children, css: cssProp, ...props }) => (
  <SambaAutoLinkBase css={{ ...unstyledStyles, ...cssProp }} {...props}>
    {children}
  </SambaAutoLinkBase>
);

Unstyled.displayName = 'SambaAutoLink.Unstyled';

export const SambaAutoLink = Object.assign(SambaAutoLinkBase, { Unstyled });
